/* (not using these - at least for now)
const optionsPaneLetterKeyOrder = 'FSJLREIOVCXM' // duplicated in ProcessingOptionsBox
const optionsPaneNumberKeyOrder = '0123456789' // duplicated in ProcessingOptionsBox
*/
import modalOpen from 'shared/js/modalOpen'

export default {
  name: 'optionsListKeyMap',
  data () {
    var optionKeys = {}
    optionKeys['down'] = () => { 
      if (this.allowOptionKeys && !(modalOpen())) this.moveToNextOption()
    }
    optionKeys['home'] = () => { 
      if (this.allowOptionKeys && !(modalOpen())) this.moveToFirstOption()
    }
    optionKeys['end'] = () => { 
      if (this.allowOptionKeys && !(modalOpen())) this.moveToLastOption()
    }
    optionKeys['up'] = () => { 
      if (this.allowOptionKeys && !(modalOpen())) this.moveToPreviousOption()
    }
    optionKeys['V'] = () => { 
      if (this.optionsBoxStyles.nikudKeyboard === 'blind' && this.allowOptionKeys
          && !(modalOpen())) {
        this.moveToNextOption()
      }
    }
    optionKeys['M'] = () => { 
      if (this.optionsBoxStyles.nikudKeyboard === 'blind' && this.allowOptionKeys
          && !(modalOpen())) {
        this.moveToPreviousOption()
      }
    }
    if (this.optionsBoxStyles.implementUserAccounts) {
      optionKeys['shift+Q'] = () => {
        if (this.allowOptionKeys && !(modalOpen())) {
          if (((this.workingOption > 0) || !(this.optionsToShow[this.workingOption].fromUserDictionary))
              && !(this.optionsToShow[this.workingOption].fromUserDictionaryNegatives)
              && (this.optionMatcherChoiceType === 'option')) {
            this.moveOptionToEnd({ whichEnd: 'top', shownOption: this.workingOption })
          }
        }
      }
      optionKeys['ctrl+Q'] = optionKeys['shift+Q']
      optionKeys['shift+x'] = () => {
        if (this.allowOptionKeys && !(modalOpen())
            && !(this.optionsToShow[this.workingOption].fromUserDictionary)) {
          if (!(this.optionsToShow[this.workingOption].fromUserDictionaryNegatives)) {
            if (this.optionsToShow[this.workingOption][this.optionMatcherProperty] === this.optionMatcherValue) {
              this.moveOptionToEnd({ whichEnd: 'bottom', shownOption: this.workingOption })
            }
          } else {
            this.useNewChoice()
            this.$emit('remove-from-user-dictionary-negatives', this.workingOption)
            this.initWorkingOption()
          }
        }
      }
      if (this.optionsBoxStyles.xNegatesInBlind) optionKeys['x'] = () => { // copy of above with one extra condition
        if (this.optionsBoxStyles.nikudKeyboard === 'blind'
            && this.allowOptionKeys && !(modalOpen())
            && !(this.optionsToShow[this.workingOption].fromUserDictionary)) {
          if (!(this.optionsToShow[this.workingOption].fromUserDictionaryNegatives)) {
            if (this.optionsToShow[this.workingOption].displayText === this.optionMatcherValue) {
              this.moveOptionToEnd({ whichEnd: 'bottom', shownOption: this.workingOption })
            }
          } else {
            this.useNewChoice()
            this.$emit('remove-from-user-dictionary-negatives', this.workingOption)
            this.initWorkingOption()
          }
        }
      }
      optionKeys['alt+shift+Q'] = () => {
        if (this.allowOptionKeys && !(modalOpen())) {
          if (this.optionsToShow[this.workingOption].fromUserDictionary) {
            this.$emit('remove-from-user-dictionary', this.workingOption)
          }
        }
      }
      optionKeys['escape'] = () => { if (this.showAccountNeededPopup && !(modalOpen())) this.showAccountNeededPopup = false }
    }
    return {
      keymap: optionKeys
      // the ABOVE [starts by] creating key and value pairs like the BELOW for all the keys in the "order"
      //   'A': () => { this.changeWorkingOption(optionsPaneKeyOrder.indexOf('A')) },
      //   'X': () => { this.changeWorkingOption(optionsPaneKeyOrder.indexOf('X')) },
    }
  }
}
